import React from 'react';

import {EContentType} from 'src/constants';
import {TMessageMatcher} from 'src/containers/MessageMatchers/definitions';
import {ImageIcon} from 'src/icons';

import * as SS from '../style';
import * as S from './style';

type TProps = {
  content: TMessageMatcher['content'];
  contentType: EContentType | null;
  children: React.ReactNode;
};

export const InstagramContent = React.memo<TProps>(
  ({contentType, content: {attachment}, children}) => (
    <SS.Message>
      {contentType === EContentType.TEXT && children}
      {contentType === EContentType.IMAGE && attachment?.fileUrl && (
        <SS.Image src={attachment.fileUrl} />
      )}
      {contentType === EContentType.IMAGE && !attachment?.fileUrl && (
        <S.EmptyImage>
          <SS.Icon as={ImageIcon} />
        </S.EmptyImage>
      )}
    </SS.Message>
  ),
);

InstagramContent.displayName = 'InstagramContent';
